import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { BUTTON__CONTENT_CLASS } from "../constants";
var text = theme.text;
var paddingY = 10;
var paddingYCompact = 6;
var compactCommon = /*#__PURE__*/css([".", "{height:", ";", ";}"], BUTTON__CONTENT_CLASS, pxToRem(text.BODY.SM.lineHeight), fontSize(text.BODY.SM));
export var buttonSize = function buttonSize(compact, fullWidth) {
  if (compact && fullWidth) {
    return css(["padding:", " 0;width:100%;", ""], pxToRem(paddingYCompact), compactCommon);
  }
  if (compact) {
    return css(["padding:", " 34px;", ""], pxToRem(paddingYCompact), compactCommon);
  }
  if (fullWidth) {
    return css(["padding:", " 0;width:100%;"], pxToRem(paddingY));
  }
  return css(["padding:", " 52px;"], pxToRem(paddingY));
};